<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentRankActivityList.push"
  >
    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="活动名称" prop="activity_name" width="240"/>
    <el-table-column label="统计区间" width="240">
      <template v-slot="{ row }">
        {{ row.start_time | timeToYmdHi }} ~ {{ row.end_time | timeToYmdHi }}
      </template>
    </el-table-column>
    <el-table-column label="小程序展示" width="110">
      <template v-slot="{ row }">
        <el-tag :type="row.is_show ? 'success' : 'info'" size="small">
          {{ row.is_show ? '展示中' : '不展示' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="上榜人数" prop="student_count" width="110"/>
    <el-table-column label="已发券人数" prop="issued_count" width="120"/>
    <v-column-time value="更新时间" field="update_time" sortable=""/>
    <el-table-column label="操作" width="330">
      <template v-slot="{ row }">
        <v-list-button
          name="查看排名"
          icon="view"
          size="large"
          :to="RouteConfig.studentRankActivityRankList.to(row.id)"
          :is-last="!isAdministrator"
        />

        <template v-if="isAdministrator">
          <v-list-button :to="RouteConfig.studentRankActivityEdit.to(row.id)"/>

          <v-list-button
            name="删除"
            icon="bin"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确定要删除此活动吗？"
            :is-last="true"
          />
        </template>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`student-rank-activity-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>活动名称</span>
              <span>{{ v.activity_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>统计区间</span>
              <span>{{ v.start_time | timeToYmdHi }} ~ {{ v.end_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>上榜人数</span>
              <span>{{ v.student_count }} 人</span>
            </div>

            <div class="list-item-detail">
              <span>已发券人数</span>
              <span>{{ v.issued_count }} 人</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="查看排名"
                icon="view"
                :to="RouteConfig.studentRankActivityRankList.to(v.id)"
                :is-last="!isAdministrator"
              />

              <template v-if="isAdministrator">
                <v-list-button :to="RouteConfig.studentRankActivityEdit.to(v.id)"/>

                <v-list-button
                  name="删除"
                  icon="bin"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确定要删除此活动吗？"
                  :is-last="true"
                />
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/student-rank-activity';

export default {
  name: RouteConfig.studentRankActivityList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator']),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      this.isLoading = true;
      getLegalQueryList(this.queryList, route.query);
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
    },
    async handleDelete({ id, update_time }) {
      if (!id || !Number.isInteger(update_time)) {
        return this.$message.warning('缺少活动信息，无法删除！');
      }

      this.isDeleting = { ...this.isDeleting, [id]: true };
      const { isError } = await destroy(id, { update_time });
      this.isDeleting = { ...this.isDeleting, [id]: false };
      if (isError) return;

      this.$message.success('删除成功');
      this.load();
    },
  },
};
</script>
